import { Box, Button } from '@mui/material';
import SelectDeselectActionGroup from './select-deselect-button-group/select-deselect-button-group';

interface MyFleetVesselDeletionButtonGroupProps {
  showActionButtons: boolean;
  onShowActions: () => void;
  onDelete: () => void;
  onCancel: () => void;
  onSelectAll: () => void;
  allSelected: boolean;
  deleteDisabled: boolean;
  deleteButtonLabel: string;
}

function MyFleetVesselDeletionButtonGroup({
  showActionButtons,
  onShowActions,
  onDelete,
  onCancel,
  onSelectAll,
  allSelected,
  deleteDisabled,
  deleteButtonLabel,
}: MyFleetVesselDeletionButtonGroupProps) {
  return (
    <Box
      sx={{
        flexGrow: 1,
        minWidth: '48%',
      }}
    >
      {showActionButtons ? (
        <SelectDeselectActionGroup
          onDelete={onDelete}
          onCancel={onCancel}
          onSelectAll={onSelectAll}
          allSelected={allSelected}
          deleteDisabled={deleteDisabled}
          deleteButtonLabel={deleteButtonLabel}
        />
      ) : (
        <Button
          type="button"
          onClick={onShowActions}
          sx={{ width: '100%' }}
          data-testid="delete-group-button"
        >
          Delete Vessel(s)
        </Button>
      )}
    </Box>
  );
}

export default MyFleetVesselDeletionButtonGroup;
